import Lobby from '../screens/lobby_screen.js';
import Play from '..//screens/play_screen.js';
import LobbyExt from '../screens/lobbyext_screen.js';
import {IScreenBase, IGame, GameConfig, GameStats} from '..//lib/definitions';
import { DomEvents } from '../screens/screen_base';
import {BlockchainInfos, globalUserInfos} from '../lib/blockchainSession'
import { Dispatch, SetStateAction } from 'react';
import { ActiveNavLink } from '../ui/balance';

export class ScreenChange implements IGame{

    isChanging;
    curScreen;
    curEngine:any;
    current:IScreenBase | null;

    lobby:Lobby;
    //lobbyExt:LobbyExt;
    play:Play;
    renderMode:number;
    
    constructor(curEngine: any, renderMode : number, DAmmo : any, glDomRef: any, domEvents: DomEvents, blockchaininfos : BlockchainInfos, gameConfig : GameConfig, setactiveLinks:Dispatch<SetStateAction<ActiveNavLink>>, setuserinfos:Dispatch<SetStateAction<globalUserInfos>>, setBCInfos:Dispatch<SetStateAction<BlockchainInfos>>, setgameStats : Dispatch<SetStateAction<Array<GameStats> | null>>, settotalBonus : Dispatch<SetStateAction<number>>){
        this.isChanging = false;
        this.curScreen = '';
        this.current = null;
        this.renderMode=renderMode;

        this.curEngine = curEngine;

        this.lobby = new Lobby      ( this.curEngine, this, this.renderMode, DAmmo, glDomRef, domEvents, blockchaininfos, gameConfig, setactiveLinks, setuserinfos, setBCInfos, setgameStats, settotalBonus);
        //this.lobbyExt = new LobbyExt( this.curEngine, this, this.renderMode, glDomRef, domEvents, blockchaininfos);
        this.play =  new Play       ( this.curEngine, this, this.renderMode, DAmmo, glDomRef, domEvents, blockchaininfos, gameConfig, setactiveLinks, setuserinfos, setBCInfos, setgameStats, settotalBonus);

        /*
        this.lobby.setEngine(curEngine, renderMode, glDomRef);
        this.lobbyExt.setEngine(curEngine, renderMode, glDomRef);
        play.setEngine(curEngine, renderMode, glDomRef);
        */

        /*
        lobby.setEventObject(domEvents);
        lobbyExt.setEventObject(domEvents);
        play.setEventObject(domEvents);
        */
    }

    async changeScreen(toScreen:string, unload : boolean = true){

        if(this.curScreen == toScreen)
            return;                    

        if(this.isChanging)
            return;

        this.isChanging = true;


        if(this.current){
            this.current.stop();

            if(unload)
                this.current.unload();
        }

        this.current = null;

        localStorage.setItem("lastScreen", toScreen);

        if(toScreen === 'lobby'){
            await this.lobby.load();
            this.lobby.start();
            this.current=this.lobby;
        }

        /*
        if(toScreen === 'lobbyext'){
            this.lobbyExt.start();
            this.current=this.lobbyExt;
        }
        */
        
        if(toScreen === 'play'){
            await this.play.load();
            this.play.start();
            this.current=this.play;
        }

        this.isChanging = false;
        this.curScreen = toScreen;
    }
}

